import React, { Component } from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import {Link} from "react-router-dom";
import ModalExample from "./pop";
import './styles.css';
import ModalExample2 from "./popaddexistinguser";
import ModalExample3 from "./popfooter";
import {getStore} from '../../../index';
import 'bootstrap/dist/css/bootstrap.min.css';
import MyUploader from "../../elements/UploadDDL";
import {config} from "../../../utility/swaggerClient";
// import './styles.scss';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'datafactory.user.management1',
    description: 'Page Header Title',
    defaultMessage: 'My Data Factory'
  },
  headerSubTitle: {
    id: 'datafactory.user.management.subtitle1',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload/Update DDL files for development test enviorment'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

class ManagementDDLjdbc2 extends Component {
  
  componentDidMount(){
    this.props.getusersList(this.props.username);
    this.setState({dfid:this.props.match.params.dfid});
    this.setState({reponame:this.props.match.params.reponame});
    console.log(this.props.match.params);
    
         
    console.log(this.props.customerdfList[0]['jdbclist']);

    const newItemsdflist = [...this.props.customerdfList];
    newItemsdflist.map(item => {
      console.log(item.dfid);
      console.log(item);
        if (item.dfid == this.props.match.params.dfid){
             console.log(item['jdbclistcopyy']);
             this.setState({jdbclistForDDL:item['jdbclistcopyy']});

            }
  });
}

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      status: "",
      dfactory:"",
      uploadcontent:"",
      validfree: true,
      disableUploadBack: false,
      disableupload: true,
      jdbclistForDDL:[],
      customer:"",
      reponame:"",
      dfid:"",
      selectedjdbcname:"",
      disabledownload:true
    };
  }
  
    checkjdbc= (jdbc) => {
     // alert("jdbc");
      this.props.docheckddlexistjdbc(
        
        this.props.match.params.customer, 
        this.props.match.params.reponame,
        jdbc,
         this.setDisabledownload);

      }

  setDisableupload = (val)=>{
   // alert(val);
    console.log(val);
    this.setState({disableupload : val})
  }

  setPrjName = (name)=>{
    this.setState({projectName : name});
  }

  setDisableUploadBack = (val)=>{
    this.setState({disableUploadBack : val});
  }

  setDisabledownload = (val)=>{
    this.setState({disabledownload : val});
  }

  setUploadcontent = (s)=>{
    this.setState({uploadcontent:s});
  }

  showMessageTrue = (e) => {
    this.setState({ showMessage: true, refId :  e.value.data});
  };

  showNPupload =(type)=>{
    messages.headerSubTitle.id = type;
    const prj = type === 'upload' ? `${this.state.repo}_${Date.now()}` : this.state.stagingrepo;
    this.setState({ showUpload: true,  uploadType: type, projectName : prj});
  }


  showInviteTrue = () => {
    this.setState({ showInvite: true });
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'User Invitation'
    };
  };
  showInviteFalse = () => {
    this.setState({ showInvite: false });
    messages.headerTitle = {
      id: 'user.management',
      description: 'Page Header Title',
      defaultMessage: 'User Management'
    };
  };

  sendInvite = () => {
    this.props.inviteUser(
      this.state.firstname,
      this.state.lastname,
      this.state.email,
      this.state.phone,
      this.props.username,
      this.state.role,
      this.invitedsent
    );
  }

  invitedsent = ()=>{
    this.setState({showInviteSent : true});
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'Success'
    };
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({delUser: value.username,status: value.status,delEmail: value.email})
   // this.setState({reponame:this.props.match.params.reponame});
   this.setState({selectedjdbcname:value.name});
   this.setState({reponame:value.name,disableupload:false});

   this.checkjdbc(value.name);

  }

  sourceCodedownload = (customerid,reponame,selectedjdbcname)=>{
    console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    fetch(`${config.protocol}://${config.host}/api/user/downloadddljdbc/${this.props.match.params.customer}/${this.props.match.params.reponame}/${this.state.selectedjdbcname}`, requestOptions)
      .then(response =>
      {
        console.log(response)
        // if(response.status === 200){
        //   throw new Error("woops");
        // }
        return response.blob()
      })
      .then(data => {
        console.log(data)
        const FileDownload = require("js-file-download");
        FileDownload(data, this.props.match.params.reponame +this.state.selectedjdbcname+'.sql');
      }).catch(err => console.log(err));
  }

  checkuploadinlist = (prj,type)=>{
    const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
    console.log(type);
    if(type !== 'internal_assessment' && type !== 'internal_translation' && type !== 'internal_FreeAssessment'){
      this.props.gitlabProjects(jobType,this.props.customerid);
      // if(this.props.customerprojectList.includes(prj)){
        this.setState({repo : prj})
      // }
      // return this.props.customerprojectList.includes(prj);
      return true;
    }else{
      this.props.getStagingPrjList(jobType,this.state.repo,this.state.customer);
      // if(this.props.stagingprojectList.includes(prj)){
        this.setState({stagingrepo : prj});
      // }
      // return this.props.stagingprojectList.includes(prj);
      return true;
    }
  }

  openModal = ()=>{};

  confirmationText = "Your Admin user has been changed successfully. Please log In with the credential for new admin user."


  render() {
    return (
      <div className="preview page">
          <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
          </title>
          </Helmet>
          <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
          />
          <ModalExample
          hasTitle
          warning
          className="modal_sm"
          reset={()=>this.props.logout()}
          setClick={click => this.openModal = click}
          content={this.confirmationText}/>

         <div className="main">
          
            {/* <div
              className="panel"
              style={{
                width: '60%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            > */}
            
               {/* {!this.state.showInvite && (<div */}
              <div
                  className="panel"
                  style={{
                    width: '95%',
                    padding: '40px,40px,0,40px',
                    boxSizing: 'content-box',
                    marginTop: '15px',
                    display: 'block',
                    alignContent: 'center',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    height:'100% !important'
                  }}
              >   
                 <div
                  className="form"  style={{margin:'40px'}}
                  //model="user"
                 // onSubmit={this.sendInvite}
                 >
                    <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="data.factory.name"
                        defaultMessage="data factory name: "
                      />
                    </label>
                    <Control.text
                      model=".projectName"
                      value= {this.props.match.params.reponame}
                      //value={projectName}
                      //placeholder={uploadType==='upload' ?"same as zip file name" : ""}
                      disabled
                    />
              
                     </fieldset> 
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="data.source"
                        defaultMessage="JDBC Data Source"
                      />
                    </label>       
          {/* {this.state.jdbclistForDDL.length>0 && ( */}
            <UserTable data={this.state.jdbclistForDDL} selectItem={this.selectItem}  username={this.props.username}
             style={{ marginTop: '50ox', width:'14%',marginLeft:'-20px' }}/>
          {/* )} */}
                    {/* </LocalForm> */}


                 <label style={{ textTransform: 'capitalize',marginTop:'-80px'}}>
                      <FormattedMessage
                        id="dfddl.database"
                        defaultMessage="DDL File for Database Development Test Enviroment"
                      />
                    </label>
                     {/* {MyUploader(projectName,props.username,uploadType, "internal_translation",repo,customer,
                      uploadcontent,setUploadcontent,_setDisableUploadBack,setPrjName,checkuploadinlist,disableUploadBack,
                      disableupload,setDisableupload
                    )} */}

                    {MyUploader(this.props.match.params.reponame,this.props.username,"jdbc", this.state.selectedjdbcname,"this.reponame",this.props.match.params.customer,
                      this.uploadcontent,this.setUploadcontent,this.setDisableUploadBack,this.setPrjName,this.checkuploadinlist,false,
                      this.state.disableupload,this.setDisableupload,this.setDisabledownload
                    )}



                      <button  disabled={this.state.selectedjdbcname=='' || this.state.disabledownload}
                          className="button asse_upload2"
                          style={{ marginRight: '40px', marginLeft:'636px' }}
                          type="button"
                          onClick={() =>this.sourceCodedownload(this.state.customer, this.state.reponame,this.state.selectedjdbcname) }
                          // onClick={() => this.state.stagingrepo === "" ?
                          //   this.sourceCodedownload(this.state.customer, this.state.reponame) :
                          //   this.sourceCodedownload(this.state.customer, this.state.stagingrepo)

                          // }
                          // disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED'}
                        >
                          <FormattedMessage
                            id="dashboard.download.ddl"
                            defaultMessage="Download"
                          />
                     </button>
                     {/* <br/> <br/> <br/> */}
                       
                        <div
                          className="button-container"
                          style={{ textAlign: 'center',marginBottom:'20px' }}
                        >
                          {/* /*orignal is <Link to="/en-CA/> */}
                          <Link to="/en-CA/datafactorymanagement">    
                            <button
                              className="button"
                              style={{ marginRight: '40px' }}
                              type="button"
                              // onClick={() => this.props.clickBackHandler()}
                            >
                              <FormattedMessage
                                id="run-assessment.back.button.name1"
                                defaultMessage="Back To My Data Factory"
                            />
                          </button>
                        </Link>


                   </div>
                 </div>   
                 <br/> <br/> <br/> <br/>   
                    {/* }            */}


      
               
                {/* <UserTable data={this.props.usersList} selectItem={this.selectItem}  username={this.props.username}/> */}

          </div>
          </div>
         
          <Footer />
          </div>
    );
  }
}

ManagementDDLjdbc2.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(ManagementDDLjdbc2);



// WEBPACK FOOTER //
// ./src/components/views/ManagementDDLjdbc2/index.js